import { useTheme } from '@emotion/react'
import { Alert, Button, CircularProgress, FormControlLabel, Grid, IconButton, Switch, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Card from '@mui/material/Card';
import React, { useRef } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { jobActions } from '../../../redux/reducers/job-slice'
import { useEffect } from 'react'
import { FixedSizeList, } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import { urlToBLOB, urltoFile } from '../../../utils/basicUtils';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import Empty from '../../../components/Empty';
import useAxiosPrivate from '../../../hooks/use-axios-private';
import { APP_CURRENCY } from '../../../constants';
import { alertMsg } from '../../../utils/basicUtils';
import { Stage, Layer, Line, Image, Transformer } from 'react-konva';
import RedoIcon from '@mui/icons-material/Redo';
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const imagesArray = [
    "https://images.pexels.com/photos/1350789/pexels-photo-1350789.jpeg",
    "https://images.pexels.com/photos/923192/pexels-photo-923192.jpeg",
    "https://images.pexels.com/photos/963486/pexels-photo-963486.jpeg",
    "https://images.pexels.com/photos/1938032/pexels-photo-1938032.jpeg",
    "https://images.pexels.com/photos/416320/pexels-photo-416320.jpeg",
]

const Marker = ({ hotspot, style, onSave, onClose, onDelete, type, isOpen }) => {
    const [showText, setShowText] = useState(type === 'new');
    const [commentText, setCommentText] = useState(hotspot.text);
    return (
        <>
            <Box onClick={(e) => e.stopPropagation()}>
                <div
                    style={
                        {
                            color: "#fff",
                            position: "absolute",
                            // left: `${hotspot.x}%`,
                            // top: `${hotspot.y}%`,
                            left: `calc(${hotspot.x}% - 5px)`,
                            top: `calc(${hotspot.y}% - 3px)`,
                            backgroundColor: "#0b1345",
                            borderRadius: "50%",
                            // padding: "5px",
                            width: "15px",
                            height: "15px",
                            fontSize: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: 'center',
                            border: "2px solid #fff",
                            ...style
                        }
                    }
                    onClick={() => {
                        setShowText(prev => {
                            isOpen = !prev
                            return !prev
                        });
                        setCommentText(hotspot.text)
                    }}
                >
                    <div>{hotspot.index}</div>
                </div>
            </Box>
            {
                showText && (
                    <Box onClick={(e) => e.stopPropagation()}>
                        <Card sx={{
                            position: "absolute",
                            p: 2,
                            left: { xs: hotspot.x < 25 ? `calc(${hotspot.x}% + 40px)` : hotspot.x > 25 && hotspot.x < 75 ? `calc(${hotspot.x}% - 115px)` : `calc(${hotspot.x}% - 215px)`, sm: hotspot.x < 50 ? `calc(${hotspot.x}% + 40px)` : `calc(${hotspot.x}% - 270px)` },
                            top: hotspot.y < 50 ? `calc(${hotspot.y}% - 13px)` : `calc(${hotspot.y}% - 185px)`,
                            width: { xs: 175, sm: 230 },
                            maxWidth: "230px",
                            zIndex: 1999


                        }} >
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: { xs: 1, sm: 2 } }}>
                                <Box>
                                    <Typography sx={{ fontSize: { xs: 12, sm: 14 } }}>
                                        Add your comments below
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: "right" }}>
                                    <IconButton size='small' onClick={(e) => {
                                        if (!hotspot.text) {
                                            onClose(commentText);
                                        }
                                        setShowText(false);
                                    }}
                                    >
                                        <HighlightOffIcon sx={{ color: "grey" }} />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Box sx={{ mb: 1, width: "100%" }}>
                                <TextField
                                    autoFocus={true}
                                    id="outlined-multiline-static"
                                    label="Comments"
                                    multiline
                                    fullWidth
                                    rows={2}
                                    value={commentText}
                                    InputProps={{
                                        style: { fontSize: 14 }
                                    }}
                                    InputLabelProps={{
                                        style: { fontSize: 14 }
                                    }}
                                    onChange={(e) => setCommentText(e.target.value)}
                                />
                            </Box>
                            <Grid container sx={{ mt: { xs: 2, sm: 3 } }}>
                                <Grid item xs={6} >
                                    <Button variant='outlined' size="small" color='error' onClick={(e) => { onDelete(); setShowText(false); }}>Delete</Button>
                                </Grid>
                                <Grid item xs={6} sx={{ textAlign: "right" }}>
                                    <Button variant='contained' size="small" onClick={
                                        (e) => {
                                            e.stopPropagation();
                                            setShowText(false);
                                            if (commentText === "") {
                                                onDelete()
                                            } else {
                                                onSave(commentText)
                                            }
                                        }
                                    }>Save</Button>
                                </Grid>
                            </Grid>
                        </Card >
                    </Box >
                )
            }
        </>
    )
}
Marker.defaultProps = {
    type: 'saved'
};

const ImageSlider = ({ itemData, disabled, onImageSelect, tempHotspot, lines, draggedImages }) => {
    const [selectedImage, setSelectedImage] = useState(0)
    const onSelectHandler = (index, e) => {
        if (e.detail === 1) {
            if (tempHotspot) {
                if (selectedImage !== index) {
                    alertMsg("Save the hotspot to work on next image", 'warning')
                }
            }
            else if (!disabled) {
                setSelectedImage(index)
                onImageSelect(index)
            }
        }
    }
    return (
        <Box style={{ height: "115px" }}>
            <AutoSizer >
                {({ height, width }) => (
                    <FixedSizeList className="overflow-scroll"
                        height={height}
                        width={width}
                        itemSize={100}
                        layout={'horizontal'}
                        itemCount={itemData.length}
                    >
                        {({ index, style }) => (
                            <Box style={{ ...style, height: "90px", }} >
                                <img
                                    alt={index}
                                    onClick={
                                        (e) => {
                                            lines.length === 0 && draggedImages.length === 0 &&
                                                onSelectHandler(index, e)
                                        }
                                    }
                                    src={itemData[index].preview_url}
                                    style={
                                        {
                                            width: "90px",
                                            objectFit: 'cover',
                                            height: "90px",
                                            marginRight: "10px",
                                            borderRadius: "6px",
                                            border: index === selectedImage ? `4px solid #f764a3` : "4px solid transparent",
                                        }
                                    } />
                                {
                                    itemData[index].hotspots.length > 0
                                    &&
                                    < Box sx={{ position: 'absolute', top: "8px", right: "8px" }}>
                                        <CommentOutlinedIcon sx={{ fontSize: "15px", background: "#3f51b5", borderRadius: "50%", padding: "4px", color: "#fff" }} />
                                    </Box>
                                }
                            </Box>
                        )}
                    </FixedSizeList>
                )}
            </AutoSizer>
        </Box >

    )
}

const Comment = ({ onDelete, hotspot, index }) => {
    const theme = useTheme()
    return (
        <Box bgcolor={theme.palette.mode === "dark" ? "background.sidebar" : "#fff"} sx={{ px: 2, py: 1, mt: 1, borderRadius: "6px" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography sx={{ backgroundColor: theme.palette.mode === "dark" ? '#5a5a5a' : 'background.stripped', borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", width: "32px", height: "32px", minWidth: "32px", minHeight: "32px" }}>
                        {index + 1}
                    </Typography>
                    <Typography>
                        {hotspot.text}
                    </Typography>
                </Box>
                <IconButton
                    onClick={onDelete}
                    color='error'
                >
                    <DeleteOutlineOutlinedIcon />
                </IconButton>
            </Box>
        </Box>
    )
}

const UseImageLoader = (src, canvasDimension) => {
    const [image, setImage] = useState(null);

    const imageRef = useRef(null);
    const [ratio, setRatio] = useState({ width: 0, height: 0, newWidth: 0, newHeight: 0, imageX: 0, imageY: 0 });

    useEffect(() => {
        const img = new window.Image();
        img.onload = () => {
            const width = img.width

            const height = img.height

            const aspectRatio = width / height;


            let newWidth = canvasDimension.height;
            let newHeight = (height / width) * newWidth;

            if (newHeight > canvasDimension.height) {
                newHeight = canvasDimension.height;
                newWidth = newHeight * aspectRatio;
            }
            const imageX = (canvasDimension.width - newWidth) / 2;
            const imageY = (canvasDimension.height - newHeight) / 2;

            setRatio({ width: width, height: height, newWidth: newWidth, newHeight: newHeight, imageX: imageX, imageY: imageY, });
            setImage(img);
        };

        img.crossOrigin = "Anonymous";
        img.src = src;
        imageRef.current = img

        return () => {
            img.onload = null;
        }
    }, [src])


    return { image, ratio };
};
const BackgroundImge = ({ currentImage, canvasWidth, canvasHeight }) => {
    const { image, ratio } = UseImageLoader(currentImage, { width: canvasWidth, height: canvasHeight });
    return (
        <Image
            x={ratio.imageX}
            y={ratio.imageY}
            width={ratio.newWidth}
            height={ratio.newHeight}
            image={image}
        />
    );
};
const DraggedImages = ({ currentImage, canvasWidth, canvasHeight, isSelected, onSelect, onChange }) => {

    const { image, ratio } = UseImageLoader(currentImage.src, { width: canvasWidth, height: canvasHeight });
    const imageRef = useRef(null);
    const trRef = useRef(null);

    useEffect(() => {
        if (isSelected) {
            trRef.current.nodes([imageRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [isSelected]);
    return (
        <>
            <Image
                x={currentImage.x}
                y={currentImage.y}
                width={ratio.newWidth / 3}
                height={ratio.newHeight / 3}
                ref={imageRef}
                image={image}
                id={currentImage.id}
                rotation={currentImage.rotation ? currentImage.rotation : 0}
                scaleX={currentImage.scaleX ? currentImage.scaleX : 1}
                scaleY={currentImage.scaleY ? currentImage.scaleY : 1}
                skewX={currentImage.skewX ? currentImage.skewX : 0}
                skewY={currentImage.skewY ? currentImage.skewY : 0}
                offsetX={(ratio.newWidth / 3) / 2}
                offsetY={(ratio.newHeight / 3) / 2}
                draggable={true}
                onDragStart={(e) => { onSelect(e.target) }}
                onDragEnd={(e) => { onChange(e.target) }}
                onDragMove={(e) => { }}
                // onDblClick={(e) => { onSelect() }}
                onClick={(e) => { onSelect() }}
                onTransformEnd={(e) => { onChange(e.target) }}
            />
            {isSelected && (
                <Transformer
                    ref={trRef}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width < 5 || newBox.height < 5) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </>
    );
};
const SelectEditsStep = ({ enableNext }) => {
    const dispatch = useDispatch()
    const theme = useTheme()
    const job = useSelector(state => state.job)
    const itemData = job.media;
    const [editSelectedImage, setEditSelectedImage] = useState(0);
    const [preferences, setPreferences] = useState(false);
    const [tempHotspot, setTempHotspot] = useState(false)
    const [penMode, setPenMode] = useState(false)
    const [canvasImg, setCanvasImg] = useState(false)
    const axios = useAxiosPrivate()
    const [lines, setLines] = useState([])
    const stageRef = useRef()
    const [history, setHistory] = useState([])
    const isDrawing = useRef(false)
    const [historyIndex, setHistoryIndex] = useState(-1)
    const [isUndo, setIsUndo] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [draggedImages, setDraggedImages] = useState([])
    const [previousState, setPreviousState] = useState([])
    const dragUrl = useRef();
    const [dragMode, setDragMode] = useState(false)
    const [openSpeedDial, setOpenSpeedDial] = useState(false)
    const [resetAll, setResetAll] = useState(false)

    const [avaliablePreferencelist, setAvailablePreferencelist] = useState(false)
    const [enableEdit, setEnableEdit] = useState(job.media.every(x => x.has_thumb))
    const disableEditStyles = {}
    const [showGenerateBtn, setShowGenerateBtn] = useState(job.media.some(x => !x.has_thumb))
    const [isGenerateBtnLoading, setIsGenerateBtnLoading] = useState(false)

    const requestThumbs = async () => {
        try {
            // const resp = await axios.post('/bulk_gentate', {
            //     draft_id: job.draft_id
            // });
            setIsGenerateBtnLoading(true)
            alertMsg("Generating thumbs please wait...", 'info')
            const resp = await axios.put(`/jobs/bulk_generate_thumb/${job.draft_id}`)
            setShowGenerateBtn(false)
            dispatch(jobActions.updateJob({ media: resp.data.data.media }))
            loadCanvasImg()
            alertMsg(resp.data.message, 'success')
            setEnableEdit(true)
        }
        catch (err) {
            console.error("🚀 ~ file: SelectEditsStep.jsx:236 ~ requestThumbs ~ err:", err)
        }
        finally {
            setIsGenerateBtnLoading(false)
        }
    }

    const loadCanvasImg = async (index = 0) => {
        try {
            setCanvasImg(false)
            const BLOB = await urlToBLOB((job.media[index].marked_image ? job.media[index].marked_image.url : job.media[index].preview_url) + "?datauri=true")
            setCanvasImg(BLOB)
        }
        catch (error) {
            console.error("🚀 ~ file: SelectEditsStep.jsx:235 ~ loadCanvasImg ~ error:", error)
            setCanvasImg(false)
        }
    }

    useEffect(() => {
        enableNext(!openSpeedDial)
        return () => {
            enableNext(false)
        }
    }, [enableNext, openSpeedDial])

    useEffect(() => {
        const getPreferences = async () => {
            try {
                const resp = await axios.get(`services/preferences/${job.service_lst[0]}`,
                    {
                        params: {
                            base: 1
                        }
                    })
                setPreferences(resp.data.data.preference)
                setAvailablePreferencelist(resp.data.data.available_base_preferences)
                dispatch(jobActions.resetBilling())
                if (!job.is_user_preference_applied) {
                    resp.data.data.user_editing_preferences.forEach((pref => {
                        let preferenceObj = resp.data.data.available_base_preferences.find(preference => preference.id === pref.preference_id)
                        dispatch(jobActions.setDefaultBasePreferences([preferenceObj]))
                    }))
                }

            } catch (e) {
                console.error("🚀 ~ file: SelectEditsStep.jsx:177 ~ getPreferences ~ e:", e)
            }
        }
        getPreferences()
    }, [axios, dispatch, job.service_lst])

    useEffect(() => {
        (!showGenerateBtn) && loadCanvasImg()
    }, [showGenerateBtn])

    const handleImageEditsChange = (e, preference, index) => {
        e.target.checked
            ?
            dispatch(jobActions.addPreferencesLst(preference))
            :
            dispatch(jobActions.removePreferencesLst(preference))
    }
    const handlePreferenceList = (e, pref) => {
        dispatch(jobActions.setIsUserPreferenceApplied(true))
        e.target.checked ? dispatch(jobActions.addBasePreferencesLst(pref)) : dispatch(jobActions.removeBasePreferencesLst(pref))
    }

    const getPageTopLeft = (el) => {
        var rect = el.getBoundingClientRect();
        var docEl = document.documentElement;
        return {
            left: rect.left + (window.pageXOffset || docEl.scrollLeft || 0),
            top: rect.top + (window.pageYOffset || docEl.scrollTop || 0)
        };
    }

    const uploadImage = async (imageBlob) => {
        let filename = job.media[editSelectedImage].name.split(".")
        filename.pop()
        filename.push("jpeg")
        filename = filename.join(".")
        let formData = new FormData();
        formData.append("job_id", job.job_id);
        formData.append("image", new File([imageBlob], filename, { type: "image/jpeg" }));
        try {
            let resp = await axios.post('jobs/upload_marked_image/', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            dispatch(jobActions.updateMarkedImage({ mediaIndex: editSelectedImage, markedimage: resp.data.data }))
            setResetAll(false)
            setLines([])
            setHistory([])
            setHistoryIndex(-1)
            setDraggedImages([])
            setPenMode(false)
            setDragMode(false)
            return resp
        }
        catch (e) {
            console.error("🚀 ~ file: SelectEditsStep.jsx:312 ~ uploadImage ~ e:", e)
        }
    }
    const handleSaveChanges = async (stageRef) => {
        try {
            // const b64 = await urlToBLOB(job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url + "?datauri=true")
            // canvasRef.current.backgroundImage = b64
            // const base64 = await canvasRef.current.exportImage()
            // setCanvasImg(base64)
            // canvasRef.current.backgroundImage = base64
            // // const imageBlob = b64toBlob(base64) // buggy code
            // const imageBlob = await urltoFile(base64)
            // uploadImage(imageBlob)
            setSelectedId(null)
            // const b64 = await urlToBLOB(job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url + "?datauri=true")
            const b64 = await urlToBLOB(resetAll ? job.media[editSelectedImage].preview_url : (job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url + "?datauri=true"))
            stageRef.current.backgroundImage = b64
            const base64 = await stageRef.current.toDataURL()
            setCanvasImg(base64)
            stageRef.current.backgroundImage = base64
            const imageBlob = await urltoFile(base64)
            uploadImage(imageBlob)
        }
        catch (error) {
            console.error("🚀 ~ file: SelectEditsStep.jsx:327 ~ handleSaveChanges ~ error:", error)
        }
    }

    const handleClick = (e) => {
        if (penMode) {
            return false
        }
        // const width = e.target.width.animVal.value
        // const height = e.target.height.animVal.value
        // const coords = getPageTopLeft(e.target)
        // const x = e.pageX - coords.left - 10;
        // const y = e.pageY - coords.top - 10;

        // const xpercent = (x / width) * 100
        // const ypercent = (y / height) * 100
        // const hotspot = {
        //     text: "",
        //     x: xpercent,
        //     y: ypercent,
        //     index: job.media[editSelectedImage].hotspots.length + 1
        // }
        // setTempHotspot({ mediaIndex: editSelectedImage, ...hotspot })

        const position = stageRef.current.getPointerPosition(e)
        const xpercent = ((position.x) / 600) * 100
        const ypercent = (((position.y) / 600) * 100)
        const hotspot = {
            text: "",
            x: xpercent,
            y: ypercent,
            index: job.media[editSelectedImage].hotspots.length + 1
        }
        setTempHotspot({ mediaIndex: editSelectedImage, ...hotspot })
    }

    const handleUndo = () => {
        if (historyIndex > 0 && history.length > 0) {
            if (history[historyIndex].type === 'image') {
                const imageIndex = draggedImages.findIndex(ele => ele.id === history[historyIndex].value.id)
                let images = [...draggedImages]
                if (imageIndex !== -1) {
                    if (history[historyIndex].value.dropped) {
                        images.splice(imageIndex, 1)
                    } else {
                        const lastValue = history[historyIndex].value
                        const historyExist = images.find(img =>
                            img.id === lastValue.id &&
                            img.x === lastValue.x &&
                            img.y === lastValue.y &&
                            img.rotation === lastValue.rotation &&
                            img.scaleX === lastValue.scaleX &&
                            img.scaleY === lastValue.scaleY &&
                            img.skewX === lastValue.skewX &&
                            img.skewY === lastValue.skewY
                        )
                        if (historyExist) {
                            const available = previousState.filter(ele => ele.id === historyExist.id)
                            images.splice(imageIndex, 1, ...available)
                            setDraggedImages(images)
                            setHistoryIndex(historyIndex - 1)
                        } else {
                            images.splice(imageIndex, 1, history[historyIndex].value)
                            setDraggedImages(images)
                            setHistoryIndex(historyIndex - 1)
                        }
                    }
                    setDraggedImages(images)
                    setHistoryIndex(historyIndex - 1)
                    setIsUndo(true)
                } else {
                    setDraggedImages(draggedImages.concat([history[historyIndex].value]))
                    setIsUndo(true)
                }
            } else if (history[historyIndex].type === 'line') {
                setLines(lines.filter(prev => prev !== history[historyIndex].value))
                setHistoryIndex(historyIndex - 1)
                setIsUndo(true)
            }
        } else if (historyIndex === 0) {
            setDraggedImages([])
            setLines([])
            setHistoryIndex(historyIndex - 1)
            setIsUndo(true)
        }
        setSelectedId(null)
    }

    const handleRedo = () => {
        if (historyIndex < history.length - 1) {

            if (history[historyIndex + 1].type === "image") {
                let imageIndex;

                history[historyIndex + 1].presentValue ?
                    imageIndex = draggedImages.findIndex(ele => ele.id === history[historyIndex + 1].presentValue.id)
                    : imageIndex = draggedImages.findIndex(ele => ele.id === history[historyIndex + 1].value.id)

                const images = [...draggedImages]
                if (imageIndex !== -1) {
                    history[historyIndex + 1].presentValue ?
                        images.splice(imageIndex, 1, history[historyIndex + 1].presentValue) :
                        images.splice(imageIndex, 1, history[historyIndex + 1].value)
                    setDraggedImages(images)
                    setHistoryIndex(historyIndex + 1)
                } else {
                    setDraggedImages(draggedImages.concat([history[historyIndex + 1].value]))
                    setHistoryIndex(historyIndex + 1)
                }
            } else if (history[historyIndex + 1].type === "line") {
                setLines(lines.concat([history[historyIndex + 1].value]))
                setHistoryIndex(historyIndex + 1)
            }
        }
        setSelectedId(null)
    }

    const keyGenerator = () => {
        const keys = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let result = '';
        for (let i = 0; i < 10; i++) {
            result += keys.charAt(Math.floor(Math.random() * (keys.length)));
        }
        return result
    }

    const handleMouseDown = (e) => {
        if (penMode) {
            isDrawing.current = true;
            const pos = e.target.getStage().getPointerPosition();
            setLines([...lines, { points: [pos.x, pos.y], id: keyGenerator() }]);
        }
    }
    const handleMouseMove = (e) => {
        if (penMode && lines.length > 0) {
            if (!isDrawing.current) {
                return;
            }
            const stage = e.target.getStage();
            const point = stage.getPointerPosition();
            let lastLine = lines[lines.length - 1];
            lastLine.points = lastLine.points.concat([point.x, point.y]);
            lines.splice(lines.length - 1, 1, lastLine);
            setLines(lines.concat());
        }
    };
    const handleMouseUp = () => {
        if (penMode) {
            isDrawing.current = false
            const lineHistory = lines.slice(-1)
            if (isUndo) {
                const updatedHistory = history.slice(0, historyIndex + 1)
                setHistory([...updatedHistory, { type: "line", value: lineHistory[0] }])
                setIsUndo(false)
            } else {
                setHistory([...history, { type: "line", value: lineHistory[0] }])
            }
            setHistoryIndex(historyIndex + 1)
        }
    };
    const handleChange = (img) => {
        let previous;
        let present;
        setDraggedImages(draggedImages.map(draged => {
            if (draged.id === img.attrs.id) {
                previous = draged
                present = { ...img.attrs, image: "", src: img.attrs.image.currentSrc, dropped: false }
                return present
            } else {
                return draged
            }
        }))
        setPreviousState(prev => prev.map(ele => ele.id === img.attrs.id ? previous : ele))
        if (isUndo) {
            const updatedHistory = history.slice(0, historyIndex + 1)
            setHistory([...updatedHistory, { type: "image", value: { ...previous, dropped: false }, presentValue: { ...present, dropped: false } }])
            setIsUndo(false)
        } else {
            setHistory([...history, { type: "image", value: { ...previous, dropped: false }, presentValue: { ...present, dropped: false } }])
        }
        setHistoryIndex(historyIndex + 1)
    }

    return (
        job.media.length > 0 &&
        <>
            <Grid container spacing={1} sx={{ mt: 8 }}>
                <Grid item xs={12} lg={9}>
                    <Box sx={(enableEdit ? {} : disableEditStyles)}>
                        {
                            openSpeedDial && <Box sx={{ textAlign: "center", marginTop: "-25px" }}>
                                <Typography bgcolor={"warning.main"} variant='span' sx={{ padding: "4px 10px", marginTop: "-10px", color: "#fff", fontSize: "12px" }}>Edit Mode</Typography>
                            </Box>
                        }

                        <Box className={showGenerateBtn && "generat-thumb-bg"} sx={{ p: 2, border: openSpeedDial ? "1px solid orange" : " 1px solid #cdcdcd", boxShadow: openSpeedDial ? "0px 0px 3px 0px orange" : "0px 0px 3px 0px #fff", borderRadius: "12px", mr: { lg: 2 } }} >
                            <Box>
                                <Box sx={{ mb: 2 }}>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={8}>
                                                <Box sx={{ height: 52, transform: 'translateZ(0px)', flexGrow: 1, }}>
                                                    <SpeedDial
                                                        ariaLabel="SpeedDial controlled open example"
                                                        className="hotspot-dial-icon"
                                                        sx={{ position: 'absolute', bottom: 8, right: 2, }}
                                                        icon={<ModeEditOutlinedIcon fontSize="small" />}
                                                        onClose={(e, reason) => {
                                                            reason === "toggle" && handleSaveChanges(stageRef)
                                                        }}
                                                        onClick={() => { setOpenSpeedDial(!openSpeedDial) }}
                                                        direction="left"
                                                        open={openSpeedDial}
                                                    >
                                                        <SpeedDialAction
                                                            icon={<RedoIcon fontSize="small" />}
                                                            tooltipTitle="Redo"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRedo()
                                                            }}

                                                        />
                                                        <SpeedDialAction
                                                            icon={<UndoIcon fontSize="small" />}
                                                            tooltipTitle="Undo"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleUndo()
                                                            }}

                                                        />
                                                        <SpeedDialAction
                                                            icon={<RefreshIcon fontSize="small" />}
                                                            tooltipTitle="Erase All"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                setHistory([])
                                                                setDraggedImages([])
                                                                setPreviousState([])
                                                                setHistoryIndex(-1)
                                                                setLines([])
                                                                setIsUndo(false)
                                                            }}
                                                        />

                                                        <SpeedDialAction
                                                            icon={<ModeEditOutlinedIcon fontSize="small" />}
                                                            tooltipTitle={draggedImages.length === 0 ? "pen" : "Save the changes to enable pen"}
                                                            sx={{
                                                                backgroundColor: penMode ? '#a5b1ffd6' :
                                                                    ((draggedImages.length !== 0 && dragMode) ? '#d3d3d3' : ''),
                                                                opacity: draggedImages.length !== 0 && 0.5
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (draggedImages.length === 0) {
                                                                    setDragMode(false)
                                                                    setPenMode(true)
                                                                }
                                                            }}
                                                        />
                                                        <SpeedDialAction
                                                            icon={<ControlCameraIcon fontSize="small" />}
                                                            tooltipTitle={lines.length === 0 ? "drag and drop" : "Save the changes to enable virtual staging"}
                                                            sx={{
                                                                backgroundColor: dragMode ? '#a5b1ffd6' :
                                                                    ((lines.length !== 0 && penMode) ? '#d3d3d3' : ''),
                                                                opacity: lines.length !== 0 && 0.5
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (lines.length === 0) {
                                                                    setPenMode(false)
                                                                    setDragMode(true)
                                                                }
                                                            }}
                                                        />
                                                        <SpeedDialAction
                                                            icon={<SaveIcon fontSize="small" />}
                                                            tooltipTitle="Save image"
                                                            onClick={() => { handleSaveChanges(stageRef); setPenMode(false); setDragMode(false) }}

                                                        />
                                                        <SpeedDialAction
                                                            icon={<RestartAltIcon fontSize="small" />}
                                                            tooltipTitle="reset all"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                setResetAll(true)
                                                                dispatch(jobActions.removeAllHotspotByIndex(editSelectedImage))
                                                                setDragMode(false)
                                                                setPenMode(false)
                                                                setHistory([])
                                                                setDraggedImages([])
                                                                setPreviousState([])
                                                                setHistoryIndex(-1)
                                                                setLines([])
                                                                setIsUndo(false)
                                                            }}

                                                        />
                                                        {
                                                            draggedImages.length > 0 && selectedId && !penMode && <SpeedDialAction
                                                                icon={<DeleteIcon sx={{ color: "#e93c3c" }} />}
                                                                sx={{ backgroundColor: "#ff9c9c" }}
                                                                tooltipTitle={"Delete Selected"}
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    setDraggedImages(draggedImages.filter(img => img.id !== selectedId))
                                                                    setSelectedId(null)
                                                                }}
                                                            />
                                                        }

                                                        <SpeedDialAction
                                                            icon={<CloseIcon fontSize="small" />}
                                                            tooltipTitle="close"
                                                            onClick={() => { handleSaveChanges(stageRef); setPenMode(false); setDragMode(false) }}
                                                        />
                                                    </SpeedDial>
                                                </Box>

                                                <Box
                                                    onClick={() => {
                                                        !openSpeedDial && handleClick()
                                                    }}
                                                    sx={{ height: 600, width: 600, background: "#fff", position: "relative" }}
                                                    onDrop={(e) => {
                                                        e.preventDefault();
                                                        if (!penMode) {
                                                            stageRef.current.setPointersPositions(e);
                                                            const droped = {
                                                                ...stageRef.current.getPointerPosition(),
                                                                src: dragUrl.current,
                                                                id: keyGenerator(),
                                                            }
                                                            if (isUndo) {
                                                                const updatedHistory = history.slice(0, historyIndex + 1)
                                                                setHistory([...updatedHistory, { type: "image", value: { ...droped, dropped: true } }])
                                                                setIsUndo(false)
                                                            } else {
                                                                setHistory([...history, { type: "image", value: { ...droped, dropped: true } }])
                                                            }
                                                            setPreviousState(previousState.concat([{ ...droped, dropped: true }]))
                                                            setDraggedImages(draggedImages.concat([{ ...droped, dropped: true }]));
                                                            setHistoryIndex(historyIndex + 1)
                                                        }
                                                    }}
                                                    onDragOver={(e) => e.preventDefault()}
                                                >
                                                    {/* <Box onClick={handleClick} >
                                                    <ReactSketchCanvas
                                                        className={penMode ? "pen" : ""}
                                                        ref={canvasRef}
                                                        style={{
                                                            border: '0.0625rem solid #cdcdcd',
                                                            borderRadius: '0.25rem',
                                                            touchAction: penMode ? 'none' : 'auto'
                                                        }}
                                                        width="100%"
                                                        height="450px"
                                                        strokeWidth={4}
                                                        strokeColor="red"
                                                        exportWithBackgroundImage={false}
                                                        allowOnlyPointerType={penMode ? 'all' : 'disable'}
                                                        preserveBackgroundImageAspectRatio={"xMidYMid  meet"}
                                                        backgroundImage={(canvasImg ? canvasImg : (job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url))}
                                                    />
                                                </Box> */}


                                                    <Stage
                                                        className={penMode ? "pen" : ""}
                                                        ref={stageRef}
                                                        width={600}
                                                        height={600}
                                                        onMouseDown={handleMouseDown}
                                                        onMousemove={handleMouseMove}
                                                        onMouseup={handleMouseUp}
                                                        onMouseEnter={(e) => { e.evt.buttons !== 0 && (isDrawing.current = true) }}
                                                        onMouseLeave={() => { isDrawing.current = false }}
                                                        onClick={() => { selectedId && setSelectedId(null); }}
                                                    >
                                                        <Layer >
                                                            <BackgroundImge
                                                                // currentImage={(canvasImg ? canvasImg : (job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url))}
                                                                currentImage={resetAll ? job.media[editSelectedImage].preview_url : (canvasImg ? canvasImg : (job.media[editSelectedImage].marked_image ? job.media[editSelectedImage].marked_image.url : job.media[editSelectedImage].preview_url))}
                                                                canvasWidth={600}
                                                                canvasHeight={600}
                                                            />
                                                            {draggedImages.length > 0 && draggedImages.map((img, index) => {
                                                                return <DraggedImages
                                                                    key={index}
                                                                    currentImage={img}
                                                                    canvasHeight={600}
                                                                    canvasWidth={800}
                                                                    isSelected={img.id === selectedId}
                                                                    onSelect={() => setSelectedId(img.id ? img.id : null)}
                                                                    onChange={handleChange}
                                                                />
                                                            })}
                                                        </Layer>
                                                        <Layer>
                                                            {lines.length > 0 && lines.map((line, i) => (
                                                                <Line
                                                                    key={i}
                                                                    points={line.points}
                                                                    stroke="red"
                                                                    strokeWidth={5}
                                                                    tension={0.5}
                                                                    lineCap="round"
                                                                    lineJoin="round"
                                                                    globalCompositeOperation={'source-over'}
                                                                />
                                                            ))}
                                                        </Layer>
                                                    </Stage>
                                                    {
                                                        job.media[editSelectedImage].hotspots.map((hotspot, index) =>
                                                            <Marker key={`${editSelectedImage}${index}`} hotspot={{ ...hotspot, index: index + 1 }}
                                                                onSave={(text) => {
                                                                    dispatch(jobActions.updateHotspot({
                                                                        mediaIndex: editSelectedImage, hotspotIndex: index, hotspotText: text
                                                                    }))
                                                                }}
                                                                onClose={(text) => {
                                                                    if (!text) {
                                                                        dispatch(jobActions.removeHotspot({ mediaIndex: editSelectedImage, hotspotIndex: index }))
                                                                    }
                                                                }}
                                                                onDelete={() => {
                                                                    dispatch(jobActions.removeHotspot({ mediaIndex: editSelectedImage, hotspotIndex: index }))
                                                                }}
                                                            />
                                                        )
                                                    }
                                                    {tempHotspot && <Marker hotspot={tempHotspot} type='new'
                                                        onSave={async (text) => {
                                                            let hotspot = { x: tempHotspot.x, y: tempHotspot.y, text: text }
                                                            await handleSaveChanges(stageRef)
                                                            dispatch(jobActions.addHotspot({ mediaIndex: editSelectedImage, hotspot: hotspot }))
                                                            setTempHotspot(false)
                                                        }}
                                                        onClose={() => {
                                                            setTempHotspot(false)
                                                        }}
                                                        onDelete={() => {
                                                            setTempHotspot(false)
                                                        }}
                                                    />}
                                                </Box>
                                                {dragMode &&
                                                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                                        <Box className="overflow-scroll" sx={{ display: "flex", alignItems: "center", gap: 2, width: 800, overflowY: "auto", borderRadius: 2, background: "#f5f5f52e", boxShadow: "1px 1px 2px 2px #0b134530", pb: 1 }} >
                                                            {
                                                                imagesArray.map((img, index) => {
                                                                    return <Box key={index} sx={{ height: 150, width: 150, minWidth: 150 }}>
                                                                        <img draggable={true} onDragStart={(e) => {
                                                                            dragUrl.current = e.target.src;
                                                                        }} src={img} style={{ height: "90%", width: "90%", objectFit: "contain", marginTop: 10 }} alt="" />
                                                                    </Box>
                                                                })
                                                            }
                                                        </Box>
                                                    </Box>
                                                }
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <Box sx={{ mb: 2, textAlign: 'right' }}>
                                                    {/* <FormControlLabel
                                                    value="start"
                                                    control={<Switch color="primary" value={editMode} onChange={e => setEditMode(e.target.checked)} />}
                                                    label="Enable Editing Mode"
                                                    labelPlacement="start"
                                                /> */}
                                                    <Button variant='outlined' onClick={() => { handleSaveChanges(stageRef) }} >Save Changes</Button>
                                                </Box>
                                                <Box sx={{ mb: 2 }}>
                                                    <Alert severity="info">Note : Click the image to create the hotspot</Alert>

                                                </Box>
                                                <Box maxHeight={365} className="overflow-scroll" sx={{ overflowY: "auto", pr: 1 }}>
                                                    <Typography sx={{ fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Comments</Typography>
                                                    {job.media[editSelectedImage].hotspots.length > 0
                                                        ?
                                                        job.media[editSelectedImage].hotspots.map(
                                                            (hotspot, index) => (
                                                                hotspot.text && <Comment key={index} {...{ hotspot, index }} onDelete={() => dispatch(jobActions.removeHotspot({ mediaIndex: editSelectedImage, hotspotIndex: index }))} />
                                                            )
                                                        )
                                                        :
                                                        <Empty icon={<ModeEditOutlinedIcon />} text="No comments" />
                                                    }
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </Box >
                                <ImageSlider
                                    // disabled={penMode}
                                    disabled={penMode || dragMode || openSpeedDial}
                                    itemData={itemData}
                                    tempHotspot={tempHotspot}
                                    onImageSelect={(index) => {
                                        if (!openSpeedDial) {
                                            if (editSelectedImage === index) {
                                                return false
                                            }
                                            setEditSelectedImage(index);
                                            // canvasRef.current.clearCanvas()
                                            loadCanvasImg(index)
                                        }
                                    }}
                                    lines={lines}
                                    draggedImages={draggedImages}

                                />
                            </Box>
                            {showGenerateBtn &&
                                <Box sx={{ position: "absolute", zIndex: "1", left: "50%", top: "50%", transform: `translate(-50%, -50%)`, textAlign: "center" }}>
                                    <Box>
                                        {
                                            isGenerateBtnLoading ? <Typography sx={{ fontSize: "20px", fontWeight: 500, color: "#343434" }}>Hold tight! while we generate thumbs</Typography> : <Typography sx={{ fontSize: "20px", fontWeight: 500, color: "#343434" }}>To give instructions, You need to generate thumbs</Typography>
                                        }
                                    </Box>
                                    <Box sx={{ mt: 1 }}>
                                        <Button className='generate-thumb-btn' disabled={isGenerateBtnLoading} variant='contained' onClick={() => { requestThumbs() }} >Generate thumbs {isGenerateBtnLoading && <CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", ml: 1, color: "#fff" }} />}</Button>
                                    </Box>
                                </Box>
                            }
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={3}>
                    <Box sx={{ mb: 2, marginTop: { xs: 2, lg: 0 } }}>
                        <Typography sx={{ fontSize: { xs: 18, xl: 20 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                            Editing Preference
                        </Typography>
                        <Typography sx={{ mt: 1, fontSize: '14px' }}>
                            Select the options you would like to have on your photo to default.
                        </Typography>
                    </Box>

                    <Box className="overflow-scroll" sx={{ maxHeight: "190px", overflow: "auto", pl: { xs: 1.3 }, mt: { xs: 2, lg: 0 }, mb: 2 }}>
                        {avaliablePreferencelist || preferences ?
                            <Grid container spacing={0}>

                                {avaliablePreferencelist.map((value, index) => {
                                    return (
                                        <Grid item xs={12} md={6} lg={12} key={index}>
                                            <Box key={index}>
                                                <FormControlLabel
                                                    className='preferenceSwitch'
                                                    control={<Switch
                                                        checked={job.base_preferences_lst.includes(value.id)}
                                                        onChange={(e) => { handlePreferenceList(e, value, index) }} />}
                                                    label={`${value.name} (${APP_CURRENCY.currency_symbol} ${value.price})`}
                                                />
                                            </Box>
                                        </Grid>
                                    )
                                })}
                                {preferences.map((value, index) => {
                                    return (
                                        <Grid item xs={12} md={6} lg={12} key={index}>
                                            <Box>
                                                <FormControlLabel
                                                    className='preferenceSwitch'
                                                    control={
                                                        <Switch
                                                            checked={job.preferences_lst.includes(value.preference_id)}
                                                            onChange={(e) => { handleImageEditsChange(e, value, index) }}
                                                        />
                                                    }
                                                    label={`${value.preference_name} (${APP_CURRENCY.currency_symbol} ${value.cost})`}
                                                />
                                            </Box>
                                        </Grid>
                                    )
                                })}

                            </Grid> : <Box sx={{ height: "190px", background: "#ebecf0", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <CircularProgress />
                            </Box>
                        }
                    </Box>

                    <Box sx={{ marginTop: "10px", width: "100%", }}>
                        <TextField
                            id="outlined-multiline-static"
                            label="Notes"
                            multiline
                            rows={4}
                            className="textAreaScroll"
                            sx={{ width: "100%", }}
                            value={job.notes}
                            onChange={e => dispatch(jobActions.updateNotes(e.target.value))}
                        />
                    </Box>
                    <Box sx={{ marginTop: "10px" }}>
                        {/* <Box>
                            <Typography sx={{ fontSize: "14px" }}>To know our Photo Editing procedure, Have a look into tutorial video by clicking this button</Typography>
                        </Box> */}
                        <Box mt={{ xs: 2, lg: 1 }}>
                            <Typography id="modal-modal-title" sx={{ mb: 1, fontSize: { xs: 18, xl: 20 }, textTransform: "capitalize", fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                Demo Editing procedure
                            </Typography>
                            <Box mt={{ xs: 2, lg: 0 }} sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>
                                <Card sx={{ minWidth: 250, flexGrow: 1, height: { xs: 250, sm: 450, lg: 180 } }}>
                                    <iframe title="Demo Editing Procedure" width="100%" height='100%' src="https://www.youtube.com/embed/8f6B45aP4Jo" allowFullScreen></iframe>
                                </Card>
                                {/* <FormControlLabel control={<Checkbox onChange={(e) => localStorage.setItem('hideEditingDemo', "" + e.target.checked)} />} label="Don't show this again" /> */}
                            </Box>
                        </Box>
                    </Box>

                </Grid>
            </Grid>
        </>
    )
}

export default SelectEditsStep